<!--
    Styles
-->

<style>

    .l-section {
        position: relative;
        height: 100%;
        z-index: 1;
    }

</style>



<!--
    Template
-->

<template>
    <router-view class="l-section"></router-view>
</template>



<!--
    Scripts
-->

<script>
    
    export default {
        
    }

</script>
